import { getNodeNameByType, LicenseType } from '@mprolab/sdk'
import { useThemeMediaQuery } from 'hooks/useThemeMediaQuery'
import { Flex, Text, TextVariant } from '@mprolab/uikit'

import React, { useMemo } from 'react'
import styled, { useTheme } from 'styled-components'
import loading from 'react-useanimations/lib/loading'
import UseAnimations from 'react-useanimations'

export const TableWrapper = styled(Flex)`
  width: 100%;
  padding: 24px;
  background: ${({ theme }) => theme.colors.backgroundContrast};
  ${({ theme }) => theme.mediaQueries.tablet} {
    flex-direction: column;
  }
`

export const NodeText = styled(Flex)`
  color: ${({ theme }) => theme.colors.gray6};
  span {
    color: ${({ theme }) => theme.colors.purple};
    font-weight: 700;
    margin-right: 8px;
  }
`

interface NodesInNetworkProps {
  isLoading: boolean
  data?: {
    count: number
    type: string
  }[]
}

const NodesInNetwork: React.FC<NodesInNetworkProps> = ({ data, isLoading }) => {
  const { colors } = useTheme()
  const isMobile = useThemeMediaQuery('tablet')

  const licenseOrder = [
    LicenseType.MGA_INODE, // iNODE first
    LicenseType.MGA_LIGHT, // ggNODE second
    LicenseType.MGA_REGULAR // MGA third
  ]

  const sortedData = useMemo(() => {
    return [...(data || [])].sort(
      (a, b) => licenseOrder.indexOf(a.type as LicenseType) - licenseOrder.indexOf(b.type as LicenseType)
    )
  }, [data])

  return (
    <TableWrapper>
      <Text variant={TextVariant.BODY_BIG_BOLD} mr={isMobile ? 0 : '96px'}>
        Licenses in network
      </Text>
      <Flex
        alignItems={isMobile ? 'initial' : 'center'}
        gap={isMobile ? '8px' : '32px'}
        flexDirection={isMobile ? 'column' : 'row'}
      >
        {isLoading ? (
          <UseAnimations animation={loading} strokeColor={colors.white3} />
        ) : (
          sortedData.map((node, index) => (
            <NodeText key={index} mt="8px">
              <span>{node.count}</span>
              {getNodeNameByType(node.type as LicenseType)}
            </NodeText>
          ))
        )}
      </Flex>
    </TableWrapper>
  )
}

export default NodesInNetwork
